<template lang="pug">
  .p-review
    template(v-if="reviewGalleries && reviewGalleries.length")
      .row.row--flex
        .col.s12.u-pts.u-pbs
          h3.h4 Reviews with images
      .row.row--flex.u-flex-wrap.u-flex-ai-center.row--gutter-sm
        .col.s3(v-for="review in reviewGalleries")
          a.u-block.u-border-all(href="javascript:void(0);", @click="onClickPic(review)")
            img.p-review__image.p-review__image--list.img-responsive.img-responsive--center(
              :src="dummyThumbnail",
              :alt="'Product Review: ' + review.title + ' | ' + productTitle",
              v-lazy="{src: resizedImageSrc(review, 120), error: dummyThumbnail, loading: dummyThumbnail}"
            )

    .p-review__item.c-media(v-for="review in reviews", :data-rid="review._id", :data-pid="review.product")
      .c-media__left
        vue-avatar-icon.p-review__avater(:user="review.user")
      .c-media__body
        .p-review__header
          h6.p-review__title(v-text="review.title")
          template(v-if="isLoggedIn")
            div(v-if="isReviewOwner(review)")
              .c-dropdown.c-dropdown--right
                button.c-btn.c-btn--sm.c-btn--inconspicuous.u-color-muted(data-toggle="dropdown", aria-expanded="false"): i.icon-chevron-down
                ul.c-dropdown__menu.c-menu.c-menu--vertical
                  li: a(:href="'/home/review/write?product_id=' + review.product", target="_blank") Edit
                  li: a(href="javascript:void(0)", @click='onDelete(review._id)') Delete
              vue-modal(
                :name="`delete-confirm-${review._id}`"
                :adaptive="true"
                width="90%"
                :max-width="480"
                height="auto"
              )
                .c-panel
                  .c-panel__header.u-flex.u-flex-ai-center
                    p: strong Delete Review
                  .c-panel__body.u-flex.u-flex-dir-column
                    p Are you sure you want to permanently delete this Review?
                    .u-mtm.u-flex.u-flex-jc-center.u-flex-ai-center
                      button.c-btn.c-btn--default(@click="closeModal") Cancel
                      button.c-btn.c-btn--alert.u-mlxs(@click="confirmDelete(review._id)") Delete

        .p-review__meta
          .p-review__username
            a.u-weight-bold.u-text-overflow-1(:href="'/' + review.user.mypage_name", v-text="review.user.name", rel="nofollow")
          time.p-review__date(:datetime="dateFormatted(review.posted_at, 'DD MMM. YYYY')")
            | {{dateFormatted(review.posted_at, 'fromNow')}}
            ins.u-plxs(
              :datetime="dateFormatted(review.posted_at)",
              :title="'Posted at ' + dateFormatted(review.created_at, 'DD MMM. YYYY')",
              style="text-decoration: none;",
              v-if="showEdited(review)"
            ) [Edited]
          .p-review__permalink
            a.u-fs-sm.u-color-muted(:href="'/' + review.user.mypage_name + '/reviews/' + review._id", :title="review.body", rel="nofollow") Permalink

        .p-review__rating.u-pts
          .c-rating.c-rating--sm(:data-rating="review.stars")
            .c-rating__stars

        .p-review__body.u-mbs
          .c-message.c-message--sm.c-message--warn.u-mbs(v-if="review.isReviewing && isReviewOwner(review)")
            p Your comments are being reviewed and should be published within a few business days.

          p.lh15(v-html="getReviewBodyHtml(review)")
          button.p-review__readmore.c-btn.c-btn--sm.c-btn--link(
            v-if="review.body.length > maxStringLength"
            type="button"
            @click="toggleReadmore(review)"
            v-text="review.isShowAllText ? 'Close' : 'Read more'"
          )

          .u-mtm(v-if="review.media")
            a.u-inline-block.u-border-all(href="javascript:void(0);" @click="onClickPic(review)")
              img.img-responsive(
                :src="dummyThumbnail"
                :alt="'Product Review: ' + review.title + ' | ' + productTitle"
                v-lazy="{src: resizedImageSrc(review, 320), error: dummyThumbnail, loading: dummyThumbnail}"
              )

        template(v-if="isLoggedIn")
          .p-review__helpful(v-if="!isReviewOwner(review)" :class="{'is-feedbacked': review.feedback_flag}")
            p.u-color-muted Was this review helpful?
            button.c-btn.c-btn--sm(
              type="button"
              :class="{'is-feedback-selected': review.feedback_helpful === 1}"
              @click="feedback(review._id, 1)"
            )
              | Yes
              = ' '
              span {{review.feedback.positive}}
            button.c-btn.c-btn--sm(
              type="button"
              :class="{'is-feedback-selected': review.feedback_helpful === 0}"
              @click="feedback(review._id, 0)"
            )
              | No
              = ' '
              span {{review.feedback.negative}}

    //- アップロード画像ズームモーダル
    vue-modal(
      name="zoom-review"
      :adaptive="true"
      width="100%"
      height="auto"
      :max-width="800"
      scrollable
      v-cloak
    )
      .p-review__zoom(v-if="zoomingReview")
        .p-review__photo
          img.img-responsive.img-responsive--center(
            :src="dummyThumbnail",
            :alt="zoomingReview.title",
            :title="'Product Review: ' + zoomingReview.title + ' | ' + productTitle",
            v-lazy="{src: resizedImageSrc(zoomingReview, 500), error: dummyThumbnail, loading: dummyThumbnail}",
            @click="closeModal"
          )

        .u-flex.u-flex-dir-column.u-pm
          .u-flex.u-flex-ai-center
            vue-avatar-icon(:user="zoomingReview.user")
            .p-review__meta.u-pls
              .p-review__username
                a.u-weight-bold.u-text-overflow-1(:href="'/' + zoomingReview.user.mypage_name", v-text="zoomingReview.user.name", rel="nofollow")
          .p-review__rating.u-pts.u-pbs
            .c-rating.c-rating--sm(:data-rating="zoomingReview.stars")
              .c-rating__stars
            time.p-review__date(:datetime="dateFormatted(zoomingReview.posted_at, 'DD MMM. YYYY')")
              | {{dateFormatted(zoomingReview.posted_at, 'fromNow')}}
              ins.u-plxs(
                :datetime="dateFormatted(zoomingReview.posted_at)",
                :title="'Posted at ' + dateFormatted(zoomingReview.created_at, 'DD MMM. YYYY')",
                style="text-decoration: none;",
                v-if="showEdited(zoomingReview)"
              ) [Edited]
          .p-review__header.u-mb0
            h6.p-review__title(v-text="zoomingReview.title")
          .p-review__body
            p.lh15(v-html="getReviewBodyHtml(zoomingReview)")
            button.p-review__readmore.c-btn.c-btn--sm.c-btn--link(
              v-if="zoomingReview.body.length > maxStringLength"
              type="button"
              @click="toggleReadmore(zoomingReview)"
              v-text="zoomingReview.isShowAllText ? 'Close' : 'Read more'"
            )

    hr
    .u-mtl.u-plm.u-prm
      a.c-btn.c-btn--primary.c-btn--inverse.c-btn--fill(
        v-if="enableLoadMoreReviewsButton"
        href="javascript:void(0);"
        :class='{loading: loading}'
        @click="loadReviews"
      ) See more reviews

</template>

<script>
import Vue from 'vue';
import axios from '../../../../api/common/axios';
import urlUtil from '../../../../util/url';
import reviewApi from '../../../../api/review';
import textUtil from '../../../../util/text';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import avatarIcon from '../../../avatar/avatarIcon.vue';

dayjs.extend(relativeTime);

export default Vue.extend({
  data() {
    return {
      reviews: [],
      reviewGalleries: [],
      reviewPage: 1,
      reviewCount: 15,
      maxStringLength: 500,
      enableLoadMoreReviewsButton: false,
      loading: false,
      zoomingReview: null,
      reviewDeleteModal: null
    };
  },
  components: {
    'vue-avatar-icon': avatarIcon
  },
  props: {
    userId: {
      type: String,
      default: ''
    },
    productId: {
      type: String,
      default: ''
    },
    productTitle: {
      type: String,
      default: ''
    }
  },
  mounted() {
    if (window.reviewProvider && window.reviewProvider.provider) {
      window.reviewProvider.setResolver((data) => {
        this.setReviews(data);
      });
    } else {
      this.loadReviews(null, true).then(() => {
        // Cumulative Layout Shift対策のためレビューの表示後にfooterを表示する。
        const footer = document.querySelector('footer.p-global-footer');
        if (footer) {
          footer.removeAttribute('style');
        }
      });
    }
  },
  computed: {
    isLoggedIn() {
      return this.userId !== '';
    },
    dummyThumbnail() {
      return urlUtil.cloudImageUrl('/static/shop/product_no_image.png');
    }
  },
  methods: {
    webp: urlUtil.webp,
    isReviewOwner(review) {
      return this.userId === review.user._id.toString();
    },
    showEdited(review) {
      if (!dayjs) {
        return '';
      }
      const create = dayjs(review.created_at);
      const update = dayjs(review.posted_at);
      return create.diff(update) < 0;
    },
    dateFormatted(date, format) {
      if (format == null) {
        format = '';
      }
      if (!dayjs) {
        return '';
      }
      if (format === 'fromNow') {
        return dayjs(date).fromNow();
      }
      return dayjs(date).format(format);
    },

    // レビューレスポンスの受け取り
    setReviews(reviews) {
      for (let i = 0; i < reviews.data.length; i++) {
        reviews.data[i].isShowAllText = false;
      }
      this.reviewPage = reviews.page + 1;
      this.reviews = this.reviews.concat(reviews.data);
      if (reviews.galleries) {
        this.reviewGalleries = reviews.galleries;
      }
      this.enableLoadMoreReviewsButton = reviews.page_total > reviews.page;
    },

    // レビューを読み込む
    loadReviews(event, isMounted) {
      if (event) {
        event.preventDefault();
      }
      this.loading = true;

      const params = {
        page: this.reviewPage,
        count: this.reviewCount,
        id: this.productId
      };
      if (isMounted) {
        params.photo_galleries = 1;
      }

      return axios
        .get('/api/review/get', {
          params
        })
        .then((response) => {
          if (!response.error) {
            this.setReviews(response.data);
          }
        })
        .then(() => {
          this.loading = false;
        });
    },

    // リサイズイメージURLの取得
    resizedImageSrc(review, thumbnailSize) {
      if (!review || !review.media) {
        return '';
      }
      return tom.helper.filterImageSrc(
        window.tom.conf.path.resize +
          'resize/' +
          thumbnailSize +
          '/' +
          review.media
      );
    },

    // helpful feedback を送信
    feedback(reviewId, helpful) {
      const review = this.reviews.find((r) => {
        return r._id === reviewId;
      });

      if (!review) {
        return;
      }

      reviewApi.feedback(
        {
          id: reviewId,
          helpful: helpful
        },
        (err, res) => {
          if (err || res.status !== 'ok') {
            return;
          }
          review.feedback.positive = res.feedback.positive;
          review.feedback.negative = res.feedback.negative;
          review.feedback_helpful = helpful;
          return (review.feedback_flag = res.isFeedbacked);
        }
      );
      return false;
    },

    // bodyテキストを最大文字数にtruncateするかどうかを判断しHTMLに変換して返す
    getReviewBodyHtml(review) {
      if (!review.body) {
        return '';
      }
      let text = review.body;
      if (review.body.length > this.maxStringLength && !review.isShowAllText) {
        text = textUtil.truncate(review.body, this.maxStringLength);
      }
      return textUtil.nl2br(textUtil.escape(text));
    },
    // bodyテキストが最大文字数に超えていた場合に全文開くか開かないか
    toggleReadmore(review) {
      review.isShowAllText = !review.isShowAllText;
    },

    // ユーザー自身のレビュー削除ボタンが押された
    onDelete(reviewId) {
      this.$modal.show(`delete-confirm-${reviewId}`);
    },

    // ユーザーのレビュー削除処理
    _delete() {
      return reviewApi.delete(
        {
          product_id: this.productId
        },
        (err, res) => {
          if (err || res.status !== 'ok') {
            return;
          }
        }
      );
    },
    // レビュー削除許可
    async confirmDelete(reviewId) {
      this.loading = true;
      await this._delete(reviewId);

      this.reviews = this.reviews.filter(r => r._id !== reviewId);
      this.$emit('change', this.reviews.length);

      this.$modal.hide(`delete-confirm-${reviewId}`);
      this.loading = false;
    },

    // アップロード写真のズーム
    onClickPic(review) {
      this.zoomingReview = review;
      this.$modal.show('zoom-review');
    },

    // モーダルイベントからのクローズ
    closeModal(event) {
      const modal = event.target.closest('[data-modal]');
      this.$modal.hide(modal.getAttribute('data-modal'));
      this.zoomingReview = null;
    }
  }
});
</script>

<style scoped>
.p-review {
  position: relative;
}
.p-review__item {
  margin-top: 1.5rem;
  padding: 1.5rem 1.5rem 0 1.5rem;
  border-top: 1px solid #d0d0d0;
  overflow: auto;
}
.p-review__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: .5em;
}
.p-review__title {
  font-weight: bold;
  overflow-wrap: break-word;
  margin-bottom: 0;
}
.p-review__meta {
  display: flex;
  align-items: center;
  color: #777;
  gap: 8px;
}
.p-review__date {
  font-size: 1.2rem;
}
.p-review__rating {
  display: flex;
  align-items: center;
  gap: 10px;
}
.p-review__body {
  padding-top: 1em;
}

.p-review__helpful {
  display: flex;
  align-items: center;
  gap: 8px;
}
.p-review__helpful.is-feedbacked .c-btn {
  background: transparent;
  border-color: transparent;
  cursor: pointer;
}
.p-review__helpful.is-feedbacked .c-btn:hover {
  background: transparent;
}
.p-review__helpful.is-feedbacked .c-btn span {
  color: #949495;
}
.p-review__helpful.is-feedbacked .c-btn.is-feedback-selected span {
  color: #0094c8;
  font-weight: bold;
}

.p-review__zoom {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
}

@media only screen and (min-width: 992px) {
  .p-review__zoom {
    position: relative;
    display: grid;
    grid-template-columns: 500px 1fr;
  }
}


</style>
